<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.RAFFLE_DRAW_TOOLS.TITLE' | translate }}</h4>

  <button mat-stroked-button type="button" (click)="previewDraw()">
    {{ 'PRESENTER.RAFFLE_DRAW_TOOLS.PREVIEW_DRAW' | translate }}
  </button>

  <button mat-stroked-button type="button" (click)="resetPreviewDraw()">
    {{ 'PRESENTER.RAFFLE_DRAW_TOOLS.RESET_PREVIEW' | translate }}
  </button>

  @if (!isTemplateMode) {
    <div class="raffle-item-select">
      @if (raffleItemsLoaded$ | async) {
        <mat-form-field>
          <mat-label>{{ 'PRESENTER.RAFFLE_DRAW_TOOLS.SELECT_RAFFLE_ITEM' | translate }}</mat-label>
          <mat-select [formControl]="raffleItemControl">
            @for (item of raffleItems$ | async; track item.uuid) {
              <mat-option [value]="item.raffle_item?.uuid">{{ item.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <div class="raffle-item-spinner-container">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      }
    </div>
  }

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="primaryColorControl"
    labelTranslateKey="PRESENTER.RAFFLE_DRAW_TOOLS.CARD_BACKGROUND_COLOUR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="primaryTextColorControl"
    labelTranslateKey="PRESENTER.RAFFLE_DRAW_TOOLS.PRIMARY_TEXT_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <mat-slide-toggle [formControl]="enableConfettiControl">
    {{ 'PRESENTER.RAFFLE_DRAW_TOOLS.ENABLE_CONFETTI' | translate }}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="enableBulkRaffleDrawControl" (change)="setWidth($event)">
    {{ 'PRESENTER.RAFFLE_DRAW_TOOLS.ENABLE_BULK_RAFFLE_DRAW' | translate }}
  </mat-slide-toggle>

  @if (enableBulkRaffleDrawControl.value) {
    <mat-slide-toggle [formControl]="showPrizeNumbersControl">
      {{ 'PRESENTER.RAFFLE_DRAW_TOOLS.SHOW_PRIZE_NUMBERS' | translate }}
    </mat-slide-toggle>
  }

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.RAFFLE_DRAW_TOOLS.OPACITY' | translate }}</mat-label>
    <input matInput type="number" min="0" max="1" step="0.05" [formControl]="opacityControl" />
  </mat-form-field>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>
</div>
